const CAP_COMO_SE_CREA_UN_BTC = {
  "id": 120,
  "title": "¿Cómo se crea un BTC?",
  "slug": "como-se-crea-un-btc",
  "type": "lesson",
  "category": "bitcoin-avanzado",
  "level": "intermediate",
  "preview": "El Bitcoin se crea digitalmente mediante el proceso de minería, utilizando el protocolo Proof of Work (PoW) y la participación de nodos que validan transacciones y generan nuevos bloques.",
  "sections": [
    {
      "heading": "¿Cómo se crea un BTC?",
      "text": [
        "El sistema **Bitcoin** es de **código abierto** y funciona mediante una **red peer-to-peer (P2P)** formada por nodos interconectados.",
        "Estos nodos son los responsables de **procesar, validar y almacenar** toda la información de las transacciones realizadas dentro de la blockchain.",
        "El protocolo Bitcoin está definido en su **whitepaper**, donde se indica, entre otras cosas, **cómo se crean los BTC**."
      ],
      "list": [
        "Bitcoin es una red abierta, pública y sin intermediarios.",
        "Cada nodo mantiene una copia de la blockchain.",
        "La creación de BTC ocurre únicamente mediante minería."
      ]
    },
    {
      "heading": "Blockchain, bloques y prueba de trabajo (PoW)",
      "text": [
        "La blockchain está formada por **bloques encadenados** mediante funciones matemáticas y criptográficas.",
        "Cada bloque se genera utilizando un sistema llamado **Proof of Work (PoW)** o **Prueba de Trabajo**.",
        "PoW obliga a los nodos participantes a **resolver un problema matemático complejo**, utilizando gran poder computacional.",
        "Este proceso se conoce como **minería**, y requiere grandes cantidades de energía eléctrica y recursos."
      ],
      "bluepoint": [
        "PoW protege la red contra ataques y falsificaciones.",
        "Cada bloque contiene transacciones válidas más un hash de referencia.",
        "Los mineros compiten entre sí para encontrar la solución del bloque."
      ]
    },
    {
      "heading": "¿Cómo se genera un BTC?",
      "text": [
        "Es por medio del proceso de **minería** que se genera cada nuevo bitcoin.",
        "Cada vez que un nodo encuentra la solución válida al acertijo matemático, **se crea un nuevo bloque**.",
        "El nodo minero recibe una **recompensa en BTC** por su trabajo, conocida como **recompensa de bloque**.",
        "Además, también recibe las **comisiones de las transacciones** contenidas en ese bloque."
      ],
      "list": [
        "La recompensa por bloque disminuye en cada halving.",
        "El minero ganador incluye una transacción especial: la coinbase.",
        "Solo mediante minería se crean nuevos BTC."
      ]
    },
    {
      "heading": "Proceso de generación de un BTC",
      "list": [
        "** Los BTC se generan a través de la minería digital.** Bitcoin es una moneda exclusivamente digital, descentralizada y no existe ninguna entidad o gobierno que regule su emisión.",
        "** Bitcoin está programado para producir una cantidad fija de BTC cada ~10 minutos.** Los mineros son usuarios que aportan poder de cálculo para realizar este proceso y validar transacciones.",
        "** Los nodos mineros** recopilan transacciones desde el **mempool**, las agrupan, verifican firmas digitales y añaden una función de bloqueo criptográfico.",
        "** El minero** realiza un proceso para encontrar un hash válido a un problema matemático usando SHA-256, probando millones de combinaciones hasta que acierta.",
        "** El primer nodo** que encuentra el hash válido genera el nuevo bloque y recibe la recompensa (nuevos BTC + comisiones). Incluye la coinbase en el bloque.",
        "** Estas nuevas monedas aún no existen físicamente**: se crean en ese momento y se ponen en circulación tras determinadas confirmaciones.",
        "** Para minar Bitcoin** hoy es necesario un hardware especializado (ASIC, FPGA o GPU), un software de minería y acceso a energía eléctrica.",
        "** La función hash** empleada es **SHA-256**, junto con una variable llamada nonce, que cambia constantemente para ajustar la dificultad de minería."
      ]
    },
    {
      "heading": "Hash, SHA-256 y el papel del nonce",
      "text": [
        "En el proceso de minería, la función hash utilizada es **SHA-256**, que transforma cualquier cantidad de datos en una cadena alfanumérica de longitud fija.",
        "Resolver el bloque implica **probar millones de hashes**, modificando el valor del **nonce**, hasta encontrar uno que cumpla las condiciones de dificultad.",
        "El **nonce** es un número aleatorio que cambia constantemente para **aumentar o disminuir la dificultad** de minería, garantizando seguridad y estabilidad en la red."
      ],
      "list": [
        "SHA-256 genera un hash único, irreversible y verificable.",
        "El nonce controla la dificultad del minado.",
        "Encuentra un hash válido → Se genera un bloque → Se crean BTC."
      ]
    }
  ]
};

export default CAP_COMO_SE_CREA_UN_BTC;
